function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import gettext from 'js-utils/gettext';
import moment from 'js-utils/moment';
import FormField from '../formField/FormField';
import Select from '../select/Select';
import { LINKS_PROP_TYPE } from './constants';
import { VALUES_PROP_TYPE } from '../select/constants';
var CURRENT_YEAR = moment().format('YYYY');

var GlobalFooterLink = function GlobalFooterLink(_ref) {
  var url = _ref.url,
      children = _ref.children,
      linkAttrs = _objectWithoutProperties(_ref, ["url", "children"]);

  return React.createElement("a", _extends({}, linkAttrs, {
    href: url,
    className: "eds-global-footer__link"
  }), children);
};

var GlobalFooterLinks = function GlobalFooterLinks(_ref2) {
  var links = _ref2.links;
  var linkComponents = links.map(function (_ref3, index) {
    var url = _ref3.url,
        content = _ref3.content,
        additionalClassName = _ref3.additionalClassName,
        linkAttrs = _objectWithoutProperties(_ref3, ["url", "content", "additionalClassName"]);

    var isLast = index === links.length - 1;
    var itemClassName = classNames({
      'eds-global-footer__link-bullet': !isLast
    }, 'eds-global-footer__horizontal-link-item', additionalClassName);
    var key = "".concat(url).concat(content);
    return React.createElement("li", {
      key: key,
      className: itemClassName,
      "data-spec": "global-footer-link-item"
    }, React.createElement(GlobalFooterLink, _extends({}, linkAttrs, {
      url: url
    }), content));
  });
  return React.createElement("ul", {
    className: "eds-l-mar-all-0 eds-l-pad-hor-0"
  }, linkComponents);
};

var GlobalFooterGeneralLinks = function GlobalFooterGeneralLinks(_ref4) {
  var generalLinks = _ref4.generalLinks;

  if (isEmpty(generalLinks)) {
    return null;
  }

  return React.createElement("div", {
    className: "eds-global-footer__general-links eds-g-cell eds-g-cell-12-12 eds-g-cell-mn-8-12 eds-text--center",
    "data-spec": "global-footer-general-links"
  }, React.createElement(GlobalFooterLinks, {
    links: generalLinks
  }));
};

var GlobalFooterCopyright = function GlobalFooterCopyright() {
  return React.createElement("div", {
    className: "eds-global-footer__copyright eds-g-cell eds-g-cell-12-12 eds-g-cell-mn-2-12 eds-l-pad-vert-4"
  }, "\xA9 ", "".concat(CURRENT_YEAR, " Eventbrite"));
};

var GlobalFooterRegionSelector = function GlobalFooterRegionSelector(_ref5) {
  var regions = _ref5.regions,
      currentRegion = _ref5.currentRegion,
      onRegionChange = _ref5.onRegionChange;

  if (isEmpty(regions) || !currentRegion) {
    return null;
  }

  return React.createElement("div", {
    className: "eds-global-footer__region eds-g-cell eds-g-cell-12-12 eds-g-cell-mn-2-12 eds-l-pad-top-4 eds-l-pad-bot-3"
  }, React.createElement("div", {
    className: "eds-global-footer__region-selector"
  }, React.createElement(FormField, {
    label: gettext('Locale'),
    hideLabel: true,
    bottomSpacing: 0,
    htmlFor: "global-footer-select"
  }, React.createElement(Select, {
    id: "global-footer-select",
    name: "global-footer-select",
    values: regions,
    defaultValue: currentRegion,
    onChange: onRegionChange
  }))));
};

var GlobalFooterBase = function GlobalFooterBase(_ref6) {
  var generalLinks = _ref6.generalLinks,
      locales = _ref6.locales,
      currentLocale = _ref6.currentLocale,
      onLocaleChange = _ref6.onLocaleChange;
  return React.createElement("div", {
    className: "eds-global-footer__base eds-g-grid eds-l-pad-hor-6"
  }, React.createElement(GlobalFooterCopyright, null), React.createElement(GlobalFooterGeneralLinks, {
    generalLinks: generalLinks
  }), React.createElement(GlobalFooterRegionSelector, {
    regions: locales,
    currentRegion: currentLocale,
    onRegionChange: onLocaleChange
  }));
};

var GlobalFooter =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(GlobalFooter, _React$PureComponent);

  function GlobalFooter() {
    _classCallCheck(this, GlobalFooter);

    return _possibleConstructorReturn(this, _getPrototypeOf(GlobalFooter).apply(this, arguments));
  }

  _createClass(GlobalFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          generalLinks = _this$props.generalLinks,
          locales = _this$props.locales,
          currentLocale = _this$props.currentLocale,
          onLocaleChange = _this$props.onLocaleChange,
          brandSection = _this$props.brandSection,
          flexibleSection = _this$props.flexibleSection;
      return React.createElement("footer", {
        className: "eds-global-footer eds-g-grid l-mar-top-2"
      }, React.createElement("h2", {
        className: "eds-is-hidden-accessible"
      }, gettext('Site Navigation')), brandSection, flexibleSection, React.createElement(GlobalFooterBase, {
        generalLinks: generalLinks,
        locales: locales,
        currentLocale: currentLocale,
        onLocaleChange: onLocaleChange
      }));
    }
  }]);

  return GlobalFooter;
}(React.PureComponent);

_defineProperty(GlobalFooter, "propTypes", {
  /**
   * List of links shown at the bottom of the footer.
   * Typically these are the "corp links" that link to various
   * business-related pages.
   */
  generalLinks: LINKS_PROP_TYPE,

  /**
   * List of supported locales to show in a locale selector
   */
  locales: VALUES_PROP_TYPE,

  /**
   * The current locale (for setting the initially selected locale
   * in the locale seleector)
   */
  currentLocale: PropTypes.string,

  /**
   * All callback function invoked when the locale changes in the
   * locale selector
   */
  onLocaleChange: PropTypes.func,

  /**
   * React node for brand section
   */
  brandSection: PropTypes.node,

  /**
   * React node for flexible section (SEO)
   */
  flexibleSection: PropTypes.node
});

export { GlobalFooter as default };